var _style, _defs, _path, _defs2, _path2, _defs3, _path3, _defs4, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStepIcon4Filled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 182 182",
    style: {
      enableBackground: "new 0 0 182 182"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{clip-path:url(#SVGID_2_);fill:#008BD0;}\r\n\t.st1{clip-path:url(#SVGID_4_);fill:#008BD0;}\r\n\t.st2{clip-path:url(#SVGID_6_);fill:#008BD0;}\r\n\t.st3{clip-path:url(#SVGID_8_);fill:#008BD0;}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    x: 25.75,
    y: 17.29,
    width: 131.3,
    height: 147.71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_2_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.32,145.31l-23.98-13.9c-1.82-1.05-4.08,0.26-4.08,2.37v6.43H88.8c-12.64,0-24.56-4.88-33.56-13.7 c-1.24-1.25-2.44-2.55-3.54-3.89c-0.53-0.65-1.05-1.32-1.56-2.02c-6.1-8.29-9.31-18.12-9.31-28.56c0-6.37,1.19-12.51,3.51-18.21 c2.32-5.72-0.69-10.35-6.85-10.35c-2.96,0-5.69,1.74-6.82,4.49c-0.32,0.78-0.62,1.57-0.91,2.36c-2.51,6.9-3.83,14.25-3.83,21.71 c0,7.6,1.29,14.93,3.83,21.8c0.84,2.31,1.8,4.57,2.92,6.76c2.03,4.06,4.55,7.91,7.49,11.51c1.46,1.76,3.02,3.46,4.65,5.07 c11.8,11.58,27.43,17.98,43.98,17.98h18.45v6.42c0,2.1,2.27,3.42,4.08,2.37l23.98-13.9C137.13,148.99,137.13,146.36,135.32,145.31 "
  }))), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_3_",
    x: 25.75,
    y: 17.29,
    width: 131.3,
    height: 147.71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_4_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_3_",
    style: {
      overflow: "visible"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M47.56,36.98l23.98,13.9c1.82,1.05,4.08-0.26,4.08-2.37v-6.43h18.45c12.64,0,24.56,4.88,33.56,13.7 c1.24,1.25,2.44,2.55,3.54,3.89c0.53,0.65,1.05,1.32,1.56,2.02c6.1,8.29,9.31,18.12,9.31,28.56c0,6.37-1.19,12.51-3.51,18.21 c-2.32,5.72,0.69,10.35,6.85,10.35c2.96,0,5.69-1.74,6.82-4.49c0.32-0.78,0.62-1.57,0.91-2.36c2.51-6.9,3.83-14.25,3.83-21.71 c0-7.6-1.29-14.93-3.83-21.8c-0.84-2.31-1.8-4.56-2.92-6.75c-2.03-4.06-4.55-7.91-7.49-11.51c-1.46-1.76-3.02-3.46-4.64-5.07 c-11.8-11.58-27.44-17.98-43.98-17.98H75.62v-6.42c0-2.1-2.27-3.42-4.08-2.37l-23.98,13.9C45.75,33.3,45.75,35.93,47.56,36.98"
  }))), /*#__PURE__*/React.createElement("g", null, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_5_",
    x: 25.75,
    y: 17.29,
    width: 131.3,
    height: 147.71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_6_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_5_",
    style: {
      overflow: "visible"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M126.6,83.97h-1.27c-1.62,0-3.07-0.98-3.69-2.48l-2.05-4.97c-0.62-1.5-0.28-3.23,0.86-4.37l0.9-0.9 c1.56-1.57,1.56-4.11,0-5.68l-4.45-4.46c-1.56-1.57-4.09-1.57-5.65,0l-0.9,0.9c-1.14,1.15-2.86,1.49-4.36,0.87l-4.95-2.06 c-1.49-0.62-2.47-2.08-2.47-3.71v-1.28c0-2.22-1.79-4.02-4-4.02H88.3c-2.21,0-4,1.8-4,4.02v1.28c0,1.62-0.97,3.09-2.47,3.71 l-4.95,2.06c-1.49,0.62-3.21,0.28-4.36-0.87l-0.9-0.9c-1.56-1.57-4.09-1.57-5.65,0l-4.45,4.46c-1.56,1.57-1.56,4.11,0,5.68 l0.9,0.9c1.14,1.15,1.49,2.87,0.87,4.37l-2.05,4.97c-0.62,1.5-2.08,2.48-3.69,2.48h-1.27c-2.21,0-4,1.8-4,4.02v6.31 c0,2.22,1.79,4.02,4,4.02h1.27c1.62,0,3.07,0.98,3.69,2.48l2.05,4.97c0.62,1.5,0.27,3.23-0.87,4.37l-0.9,0.9 c-1.56,1.57-1.56,4.11,0,5.68l4.45,4.46c1.56,1.57,4.09,1.57,5.65,0l0.9-0.9c1.14-1.15,2.86-1.49,4.36-0.87l4.95,2.06 c1.49,0.62,2.47,2.08,2.47,3.71v1.28c0,2.22,1.79,4.02,4,4.02h6.28c2.21,0,4-1.8,4-4.02v-1.28c0-1.62,0.97-3.09,2.47-3.71 l4.95-2.06c1.49-0.62,3.21-0.28,4.36,0.87l0.9,0.9c1.56,1.57,4.09,1.57,5.65,0l4.45-4.46c1.56-1.57,1.56-4.11,0-5.68l-0.9-0.9 c-1.14-1.15-1.49-2.87-0.86-4.37l2.05-4.97c0.62-1.5,2.08-2.48,3.69-2.48h1.27c2.21,0,4-1.8,4-4.02v-6.31 C130.6,85.77,128.81,83.97,126.6,83.97 M116.99,93.2c0,1.45-1.17,2.62-2.61,2.62h-0.83c-1.05,0-2.01,0.64-2.41,1.62l-1.34,3.24 c-0.4,0.98-0.18,2.11,0.57,2.85l0.59,0.59c1.02,1.02,1.02,2.68,0,3.71l-2.9,2.91c-1.02,1.02-2.67,1.02-3.69,0l-0.59-0.59 c-0.74-0.75-1.87-0.97-2.84-0.57l-3.23,1.34c-0.98,0.4-1.61,1.36-1.61,2.42v0.83c0,1.45-1.17,2.62-2.61,2.62h-4.1 c-1.44,0-2.61-1.17-2.61-2.62v-0.83c0-1.06-0.64-2.01-1.61-2.42l-3.23-1.34c-0.98-0.4-2.1-0.18-2.84,0.57l-0.59,0.59 c-1.02,1.02-2.67,1.02-3.69,0l-2.9-2.91c-1.02-1.02-1.02-2.68,0-3.71l0.59-0.59c0.74-0.75,0.97-1.87,0.57-2.85l-1.34-3.24 c-0.4-0.98-1.35-1.62-2.41-1.62H68.5c-1.44,0-2.61-1.17-2.61-2.62v-4.12c0-1.45,1.17-2.62,2.61-2.62h0.83 c1.05,0,2.01-0.64,2.41-1.62l1.34-3.24c0.4-0.98,0.18-2.11-0.57-2.85l-0.59-0.59c-1.02-1.02-1.02-2.68,0-3.71l2.9-2.91 c1.02-1.02,2.67-1.02,3.69,0l0.59,0.59c0.74,0.75,1.87,0.97,2.84,0.57l3.23-1.34c0.98-0.4,1.61-1.36,1.61-2.42v-0.83 c0-1.45,1.17-2.62,2.61-2.62h4.1c1.44,0,2.61,1.17,2.61,2.62v0.83c0,1.06,0.64,2.01,1.61,2.42l3.23,1.34 c0.98,0.4,2.1,0.18,2.84-0.57l0.59-0.59c1.02-1.02,2.67-1.02,3.69,0l2.9,2.91c1.02,1.02,1.02,2.68,0,3.71l-0.59,0.59 c-0.74,0.75-0.97,1.88-0.57,2.85l1.34,3.24c0.4,0.98,1.35,1.62,2.41,1.62h0.83c1.44,0,2.61,1.17,2.61,2.62L116.99,93.2 L116.99,93.2z"
  }))), /*#__PURE__*/React.createElement("g", null, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_7_",
    x: 25.75,
    y: 17.29,
    width: 131.3,
    height: 147.71
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_8_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_7_",
    style: {
      overflow: "visible"
    }
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M91.44,78.5c-6.96,0-12.6,5.66-12.6,12.65c0,6.98,5.64,12.65,12.6,12.65c6.95,0,12.6-5.66,12.6-12.65 C104.03,84.16,98.39,78.5,91.44,78.5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStepIcon4Filled);
export default __webpack_public_path__ + "static/media/step_icon_4_filled.e319963eeefbe18c5ad960a61c3195d5.svg";
export { ForwardRef as ReactComponent };